import { FC } from 'react'
import { useTranslation } from 'react-i18next';
import {
    Link
} from "react-router-dom";
import Breadcrumb from '../../Components/Breadcrumb';
import TransportForm from './form';


const TransportCreate: FC = () => {  
    const { t } = useTranslation();
    return ( 
        <> 
            <Breadcrumb />

            <div className="container-fluid">

                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="card-title">
                                    { t('Ajouter un service de transport') }
                                </h4>
                                <Link type="button" to="/transport/list"
                                    className="btn waves-effect waves-light btn-primary">
                                        { t('Liste des services de transport') }
                                </Link>
                                <br />
                                <br />

                                <TransportForm state='create' transport={null} />  
                                 
                                </div>
                            </div> 
                    </div> 
                </div>

            </div>   
        </>                   
    );
}

export default TransportCreate